module.exports = __webpack_public_path__ + "img/0Q3B8639-42_H_FoamcoreMatted_MockedUp.fef56fec.jpg";